<script setup>
import { onMounted } from "vue";
import useProcessInitiationTable from "./hooks/useProcessInitiationTable";
import adjust from "./adjust.vue";
import useSystemList from "../hooks/useSystemList";

const { systemList } = useSystemList();

const {
  loading,
  processList,
  adjustRef,
  processSystem,
  handleMenu,
  getList,
  startProcessById,
} = useProcessInitiationTable();

onMounted(() => {
  getList();
});
</script>

<template>
  <zh-table-page v-bind="{ title: '流程发起' }">
    <template #header-btn></template>
    <template #search>
      <div></div>
      <!-- <el-form :inline="true">
        <el-form-item label="所属系统" prop="processSystem">
          <el-select v-model="processSystem">
            <el-option
              v-for="item in systemList"
              :key="item.id"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="Search" @click="getList()"
            >搜索</el-button
          >
          <el-button icon="Refresh" @click="getList()">重置</el-button>
        </el-form-item>
      </el-form> -->
    </template>
    <template #table>
      <el-row :gutter="15" style="margin-top: 8px" v-loading="loading">
        <el-col
          :span="8"
          v-for="(item, index) in processList"
          :key="item.processKey"
        >
          <el-card class="box-card" @click="startProcessById(item)">
            <template #header>
              <div class="card-header">
                <span style="flex: 1">{{ item.name }}</span>
                <el-tag type="danger">所属系统</el-tag>
              </div>
            </template>
            <div class="item">
              <div :id="'prefix_' + index" :ref="'prefix_' + index"></div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-pagination :total="10" layout="->, prev, pager, next" />
    </template>
  </zh-table-page>

  <adjust ref="adjustRef" />
</template>

<style scoped>
.box-card:hover {
  cursor: pointer;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item {
  height: 190px;
}

.el-col {
  margin-bottom: 15px;
}
</style>
